export const checkAccessForAsset = async (id, accessLevel, userDetail, userLoggedIn, subscriber) => {
  // define metering object
  let response = {};
  let meteringObject = {
    data: [
      {
        id: 2,
        attributes: {
          stories_count: 2,
          duration_length: 7,
          duration_unit: "days",
          content_type: "stories",
        },
      },
    ],
  };

  if (accessLevel === null || accessLevel === "public") {
    return {
      error: null,
      data: {
        data: { grantDescription: "public", isLoggedIn: userLoggedIn },
        grantReason: "SUBSCRIBER",
        granted: true,
      },
    };
  }
  if (accessLevel === "login") {
    if (!userLoggedIn || userDetail === null) {
      return {
        error: null,
        data: {
          data: {
            grantDescription: "login required to read this article",
            isLoggedIn: false,
          },
          grantReason: "LOGIN_REQUIRED",
          granted: false,
        },
      };
    } else {
      return {
        error: null,
        data: {
          data: { grantDescription: "logged in user", isLoggedIn: true },
          grantReason: "LOGIN_REQUIRED",
          granted: true,
        },
      };
    }
  }
  if (accessLevel === "subscription") {
    // Subscribers get full access to subscription articles
    if (subscriber) {
      return {
        error: null,
        data: {
          granted: true,
          grantReason: "SUBSCRIBER",
          data: {
            grantDescription: "subscriber",
            isLoggedIn: true,
          },
        },
      };
    }
    if (userDetail === null) {
      if (document.cookie.indexOf("anonymousNumberRemaining") === -1) {
        const anonymous_access_json = meteringObject;
        const anonymous_access_data = anonymous_access_json.data[0];
        const anonymous_access_limit = anonymous_access_data.attributes.stories_count;
        const anonymous_access_expiry_length = anonymous_access_data.attributes.duration_length;
        // const anonymous_access_expiry_unit =
        //   anonymous_access_data.attributes.duration_unit;

        let expiry_date = new Date(Date.now() + 86400000 * anonymous_access_expiry_length);

        response = {
          data: {
            isLoggedIn: false,
            isLast: false,
            numberRemaining: anonymous_access_limit - 1,
          },
          grantReason: "METERING",
          granted: true,
        };
        const readerID = document.cookie.split(";").find((c) => c.trim().startsWith("readerID="));
        if (readerID) {
          let encrypted_response = response.data.numberRemaining;
          let options = {
            expires: expiry_date,
            path: "/",
          };
          localStorage.setItem("anonymousExpiry", expiry_date);
          setCookie("anonymousNumberRemaining", encrypted_response, options);
          localStorage.setItem("accessStory", id);
        }
        return {
          error: null,
          data: response,
        };
      } else {
        const numberRemaining = document.cookie
          .split(";")
          .find((c) => c.trim().startsWith("anonymousNumberRemaining="));
        const numberRemaining_value = numberRemaining.split("=")[1];
        if (numberRemaining_value > 0) {
          if (localStorage.getItem("accessStory") !== id) {
            response = {
              data: {
                isLoggedIn: false,
                isLast: numberRemaining_value <= 0 ? true : false,
                numberRemaining: numberRemaining_value - 1,
              },
              grantReason: "METERING",
              granted: true,
            };
            setCookie("anonymousNumberRemaining", response.data.numberRemaining);
            localStorage.setItem("accessStory", id);
            return {
              error: null,
              data: response,
            };
          } else {
            return {
              error: null,
              data: {
                data: {
                  isLoggedIn: false,
                  isLast: numberRemaining_value <= 0 ? true : false,
                  numberRemaining: numberRemaining_value,
                },
                grantReason: "METERING",
                granted: true,
              },
            };
          }
        } else {
          return {
            error: null,
            data: {
              data: {
                grantDescription: "user is not allowed to read",
                isLoggedIn: false,
              },
              grantReason: "SUBSCRIBER",
              granted: false,
            },
          };
        }
      }
    } else if (!subscriber) {
      if (document.cookie.indexOf("loggedinNumberRemaining") === -1) {
        const anonymous_access_json = meteringObject;
        const anonymous_access_data = anonymous_access_json.data[0];
        const anonymous_access_limit = anonymous_access_data.attributes.stories_count;
        const anonymous_access_expiry_length = anonymous_access_data.attributes.duration_length;

        let expiry_date = new Date(Date.now() + 86400000 * anonymous_access_expiry_length);

        response = {
          data: {
            isLoggedIn: true,
            isLast: false,
            numberRemaining: anonymous_access_limit - 1,
          },
          grantReason: "METERING",
          granted: true,
        };

        const readerID = document.cookie.split(";").find((c) => c.trim().startsWith("readerID="));
        // console.log("readerID", readerID);
        if (readerID) {
          let encrypted_response = response.data.numberRemaining;
          let options = {
            expires: expiry_date,
            path: "/",
          };
          localStorage.setItem("loggedInExpiry", expiry_date);
          setCookie("loggedinNumberRemaining", encrypted_response, options);
          localStorage.setItem("accessStory", id);
        }
        return {
          error: null,
          data: response,
        };
      } else {
        const numberRemaining = document.cookie.split(";").find((c) => c.trim().startsWith("loggedinNumberRemaining="));
        const numberRemaining_value = numberRemaining.split("=")[1];
        if (numberRemaining_value > 0) {
          if (localStorage.getItem("accessStory") !== id) {
            response = {
              data: {
                isLoggedIn: true,
                isLast: numberRemaining_value === 0 ? true : false,
                numberRemaining: numberRemaining_value - 1,
              },
              grantReason: "METERING",
              granted: true,
            };
            setCookie("loggedinNumberRemaining", response.data.numberRemaining);
            localStorage.setItem("accessStory", id);
            return {
              error: null,
              data: response,
            };
          } else {
            return {
              error: null,
              data: {
                data: {
                  isLoggedIn: true,
                  isLast: numberRemaining_value <= 0 ? true : false,
                  numberRemaining: numberRemaining_value,
                },
                grantReason: "METERING",
                granted: true,
              },
            };
          }
        } else {
          return {
            error: null,
            data: {
              data: {
                grantDescription: "user is not allowed to read",
                isLoggedIn: true,
              },
              grantReason: "SUBSCRIBER",
              granted: false,
            },
          };
        }
      }
    }
  }
};

export const getCookie = (cookieName) => {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);

  const cookieArray = decodedCookie.split(";");

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return null;
};

export const setCookie = (cookieName, cookieValue, options = {}) => {
  const { expires, path, domain, secure } = options;
  let cookieString = encodeURIComponent(cookieName) + "=" + encodeURIComponent(cookieValue);

  if (cookieName === "anonymousNumberRemaining") {
    cookieString += "; expires=" + new Date(localStorage.getItem("anonymousExpiry"));
  } else if (cookieName === "loggedinNumberRemaining") {
    cookieString += "; expires=" + new Date(localStorage.getItem("loggedInExpiry"));
  }

  cookieString += "; path=/";

  if (domain) {
    cookieString += "; domain=" + encodeURIComponent(domain);
  }

  if (secure) {
    cookieString += "; secure";
  }
  document.cookie = cookieString;
};
